var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlCasinoFilled = function SvgHtlCasinoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.972 14h-3.97a.5.5 0 0 1-.178-.967c.3-.115.51-.665.609-1.173a5.482 5.482 0 0 1-1.02.141c-.439 0-.874-.081-1.283-.241a3.378 3.378 0 0 1-1.094-.69 3.201 3.201 0 0 1-.738-1.044 3.066 3.066 0 0 1 0-2.48 3.2 3.2 0 0 1 .738-1.044l4.623-4.363a.5.5 0 0 1 .686 0l4.623 4.363a3.162 3.162 0 0 1 1 2.284 3.162 3.162 0 0 1-1 2.283 3.446 3.446 0 0 1-2.378.932c-.34-.003-.68-.04-1.014-.109.1.493.3 1.016.591 1.137a.5.5 0 0 1 .175.838l-.014.012-.013.01-.013.01-.01.007-.01.007h-.009a.501.501 0 0 1-.257.072L9.972 14Z"
  })));
};
export default SvgHtlCasinoFilled;